import { useEffect, useMemo, useState } from "react";


function isDigitChar(ch) {
return ch >= "0" && ch <= "9";
}


export default function SlotNumber({ value, decimals = 2, prefix = "", suffix = "" }) {
const str = useMemo(() => {
const n = Number.isFinite(Number(value)) ? Number(value) : 0;
return n.toFixed(decimals);
}, [value, decimals]);


const chars = useMemo(() => str.split(""), [str]);


// For each character position, store the "reel index" we are currently showing.
// Digits use indices; non-digits will be null.
const [pos, setPos] = useState(() =>
chars.map((ch) => (isDigitChar(ch) ? 0 : null))
);


// Rebuild pos array if the formatted string length changes (rare, but safe)
useEffect(() => {
setPos(chars.map((ch) => (isDigitChar(ch) ? 0 : null)));
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [chars.length]);


useEffect(() => {
// Step 1: set each digit to a "far" start position (so it has somewhere to spin from)
// We use a reel length of 30 so it can spin multiple turns.
const start = chars.map((ch) => {
if (!isDigitChar(ch)) return null;
const digit = Number(ch);
// start far above: random 15..25 turns down
return digit + 10 + Math.floor(Math.random() * 10) + 10;
});


setPos(start);


// Step 2: next frame, set to final target so CSS transition animates
const id = requestAnimationFrame(() => {
const target = chars.map((ch) => {
if (!isDigitChar(ch)) return null;
const digit = Number(ch);
// land in the second half of the reel for consistent motion
return digit + 10;
});
setPos(target);
});


return () => cancelAnimationFrame(id);
}, [str, chars]);


// Reel items (0-9 repeated)
const reel = useMemo(
() => Array.from({ length: 30 }, (_, i) => String(i % 10)),
[]
);


return (
<span className="slotWrap" aria-label={`${prefix}${str}${suffix}`}>
{prefix ? <span className="slotStatic">{prefix}</span> : null}


{chars.map((ch, i) => {
if (!isDigitChar(ch)) return <span key={i} className="slotStatic">{ch}</span>;


const p = pos[i] ?? 0;


return (
<span key={i} className="slotDigit">
<span
className="slotReel"
style={{ transform: `translateY(calc(${-p} * var(--slotH)))` }}
>
{reel.map((x, idx) => (
<span key={idx} className="slotCell">{x}</span>
))}
</span>
</span>
);
})}


{suffix ? <span className="slotStatic">{suffix}</span> : null}
</span>
);
}